import { render, staticRenderFns } from "./ServizioPeriodicoFilter.vue?vue&type=template&id=0b6fb149&"
import script from "./ServizioPeriodicoFilter.vue?vue&type=script&lang=ts&"
export * from "./ServizioPeriodicoFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports